<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Fertilisers />
    </div>
</template>

<script>
import currentUserQuery from '@views/Fertilisers/Browse/queryCurrentUser.graphql';

import Fertilisers from '../Fertilisers/Browse.vue';

export default {
  name: 'FertilisersContainer',
  components: {
    Fertilisers,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
